import React from "react";
import Header from "./component/Header";
import Brijesh from "./component/pages/Brijesh";
import Projects from "./component/pages/Projects"
import Technologies from "./component/pages/Technologies";
import Additional from "./component/pages/Additional";
import ClientSay from "./component/pages/ClientSay";
import GetInTouch from "./component/pages/GetInTouch";
import Footer from "./component/footer/Footer";
import Stripe from "./container/Stripe";
import PaypalDemo from "./container/Paypal/PaypalDemo";

export function Main() {
    return(
        <>
            <Header/>
            <Brijesh/>
            {/*<Stripe/>*/}
            {/* <PaypalDemo/> */}
            <Projects/>
            <Technologies/>
            <Additional/>
            {/* <ClientSay/> */}
            <GetInTouch/>
            <Footer/>
        </>
    )
}